import { coreGet, coreMutate } from "../../core-api/api-client";

export type WorkspaceType =
  | "CHEMICAL_REAGENT"
  | "EMBODIED_INTELLIGENCE"
  | "GENERAL";
export type WorkspaceStatus =
  | "DRAFT"
  | "CONFIGURING"
  | "PILOT"
  | "ACTIVE"
  | "SUSPENDED"
  | "ARCHIVED";

export interface ManagedWorkspace {
  id: string;
  code: string;
  name: string;
  workspaceType: WorkspaceType;
  status: WorkspaceStatus;
  defaultLanguage: string | null;
  defaultTimezone: string | null;
  defaultCurrency: string | null;
  createdAt: string;
  updatedAt: string;
  counts: { memberships: number; teams: number; mailboxes: number };
}

export interface WorkspaceAdministrationPage {
  items: ManagedWorkspace[];
  total: number;
  page: number;
  limit: number;
  hasNext: boolean;
  permissions: { create: boolean; manage: boolean; disable: boolean };
  isPlatformAdministrator: boolean;
}

export interface SaveWorkspaceInput {
  code?: string;
  name: string;
  workspaceType: WorkspaceType;
  defaultLanguage: string;
  defaultTimezone: string;
  defaultCurrency: string;
  reason: string;
}

export function loadManagedWorkspaces(
  query: {
    search?: string;
    status?: string;
    workspaceType?: string;
    page?: number;
    limit?: number;
  },
  signal?: AbortSignal,
) {
  const params = new URLSearchParams();
  if (query.search) params.set("search", query.search);
  if (query.status) params.set("status", query.status);
  if (query.workspaceType) params.set("workspaceType", query.workspaceType);
  params.set("page", String(query.page ?? 1));
  params.set("limit", String(query.limit ?? 30));
  return coreGet<WorkspaceAdministrationPage>(
    `/auth/admin/workspaces?${params}`,
    signal,
  );
}

export function createWorkspace(input: SaveWorkspaceInput) {
  return coreMutate<ManagedWorkspace>("/auth/admin/workspaces", "POST", input);
}

export function updateWorkspace(id: string, input: SaveWorkspaceInput) {
  return coreMutate<ManagedWorkspace>(
    `/auth/admin/workspaces/${encodeURIComponent(id)}`,
    "PUT",
    input,
  );
}

export function disableWorkspace(id: string, reason: string) {
  return coreMutate<{ disabled: true }>(
    `/auth/admin/workspaces/${encodeURIComponent(id)}/disable`,
    "POST",
    { reason },
  );
}
